// extracted by mini-css-extract-plugin
export default {"confirmationWrapper":"FormEdit_confirmationWrapper__C-sAc","othersWrapper":"FormEdit_othersWrapper__FOTk0"};